module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DetailPage', {
    staticClass: "order-add-box",
    attrs: {
      "name": _vm.mode == 'save' ? '新增订单' : '编辑订单'
    },
    scopedSlots: _vm._u([{
      key: "detailMain",
      fn: function() {
        return [_c('div', {
          staticClass: "wrapper"
        }, [_c('header', {
          staticClass: "order-add-hd"
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "用户类型",
            "required": ""
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          model: {
            value: (_vm.person),
            callback: function($$v) {
              _vm.person = $$v
            },
            expression: "person"
          }
        }, _vm._l((_vm.persons), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "选择用户",
            "required": ""
          }
        }, [(_vm.person == '2') ? _c('el-input', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "readonly": "readonly",
            "placeholder": "请选择",
            "clearable": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.handleUser(2)
            }
          },
          model: {
            value: (_vm.checkPerson),
            callback: function($$v) {
              _vm.checkPerson = $$v
            },
            expression: "checkPerson"
          }
        }) : _c('el-input', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "readonly": "readonly",
            "placeholder": "请选择",
            "clearable": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.handleUser(1)
            }
          },
          model: {
            value: (_vm.checkUser),
            callback: function($$v) {
              _vm.checkUser = $$v
            },
            expression: "checkUser"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "生效时间",
            "required": ""
          }
        }, [_c('el-date-picker', {
          staticStyle: {
            "width": "210px"
          },
          attrs: {
            "type": "date",
            "placeholder": "生效时间",
            "clearable": false
          },
          model: {
            value: (_vm.effectiveTime),
            callback: function($$v) {
              _vm.effectiveTime = $$v
            },
            expression: "effectiveTime"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "订单类型",
            "required": ""
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "订单类型"
          },
          on: {
            "change": _vm.handerOrderType
          },
          model: {
            value: (_vm.orderType),
            callback: function($$v) {
              _vm.orderType = $$v
            },
            expression: "orderType"
          }
        }, _vm._l((_vm.orderTypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('section', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.listLoading),
            expression: "listLoading"
          }],
          staticClass: "order-add-bd"
        }, [_c('div', {
          staticClass: "product-list"
        }, [_c('h4', {
          staticClass: "list-hd title"
        }, [_vm._v("选择产品")]), _vm._v(" "), _c('ul', {
          staticClass: "list-bd fit-w"
        }, _vm._l((_vm.proList), function(item) {
          return _c('li', {
            key: item.id,
            staticClass: "list-item",
            class: {
              active: _vm.selectProList.findIndex(function (data) { return data.id == item.id; }) > -1
            },
            on: {
              "click": function($event) {
                return _vm.handerProduct(item)
              }
            }
          }, [_c('span', {
            staticClass: "dnnfont iconaccomplish-filled"
          }), _vm._v(" "), _c('img', {
            staticClass: "proLogo",
            attrs: {
              "src": item.logo,
              "alt": ""
            }
          }), _vm._v(" "), _c('h4', {
            staticClass: "proName"
          }, [_vm._v(_vm._s(item.name))])])
        }), 0)]), _vm._v(" "), _c('div', {
          staticClass: "product-list-selected"
        }, [_c('h4', {
          staticClass: "title"
        }, [_vm._v("订单清单")]), _vm._v(" "), _c('article', {
          staticClass: "fit-w list-selected-info"
        }, [_c('header', {
          staticClass: "tab-hd"
        }, [_vm._v("已选择" + _vm._s(_vm.selectProList.length) + "个产品")]), _vm._v(" "), _c('SelectedProduct', {
          attrs: {
            "productLists": _vm.selectProList,
            "isEdit": true
          },
          on: {
            "del": function (data) { return _vm.handerProduct(data); }
          }
        })], 1)])])]), _vm._v(" "), _c('footer', {
          staticClass: "order-add-ft",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          staticClass: "order-evaluate",
          staticStyle: {
            "color": "#EB6264"
          },
          attrs: {
            "label": "预估价格:"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.evaluatePrice) + " 元\n          ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          staticClass: "order-total",
          attrs: {
            "label": "订单总价:"
          }
        }, [_c('el-input', {
          staticClass: "price",
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "disabled": _vm.isOrderTest,
            "oninput": "this.value=this.value.replace(/[^\\d]/g,'');"
          },
          model: {
            value: (_vm.totalPrice),
            callback: function($$v) {
              _vm.totalPrice = $$v
            },
            expression: "totalPrice"
          }
        }, [_c('template', {
          slot: "append"
        }, [_vm._v("元")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
          staticClass: "ft-submit",
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', [_c('el-button', {
          staticClass: "gradual",
          attrs: {
            "type": "primary",
            "loading": _vm.orderSubLoading,
            "disabled": _vm.selectProList.length == 0
          },
          on: {
            "click": _vm.orderSubmit
          }
        }, [_vm._v("提交订单")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "订单账户",
            "visible": _vm.orderVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.orderVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs2
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "账号 / 姓名",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.dialogLoading),
            expression: "dialogLoading"
          }],
          ref: "users",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.users,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "row-click": _vm.handleSelectionChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-checkbox', {
                model: {
                  value: (scope.row.checked),
                  callback: function($$v) {
                    _vm.$set(scope.row, "checked", $$v)
                  },
                  expression: "scope.row.checked"
                }
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "130",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "softtype",
            "label": "软件类型",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding": "10px 0"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": " prev, pager, next",
            "current-page": _vm.pageNumber2,
            "page-size": _vm.pageSize2,
            "total": _vm.total2
          },
          on: {
            "current-change": _vm.handleCurrentChange2
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.orderVisible = false, _vm.searchText = ''
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.orderLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.orderUserSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "订单账户",
            "visible": _vm.personVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.personVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs3
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "企业名称",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getPerson(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getPerson(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.dialogLoading),
            expression: "dialogLoading"
          }],
          ref: "personList",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.personList,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "row-click": _vm.handleSelectionChange3
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-checkbox', {
                on: {
                  "change": _vm.changeFun3
                },
                model: {
                  value: (scope.row.checked),
                  callback: function($$v) {
                    _vm.$set(scope.row, "checked", $$v)
                  },
                  expression: "scope.row.checked"
                }
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "managername",
            "label": "公司管理员",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "企业名称",
            "min-width": "180",
            "show-overflow-tooltip": ""
          }
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding": "10px 0"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": " prev, pager, next",
            "current-page": _vm.pageNumber3,
            "page-size": _vm.pageSize3,
            "total": _vm.total3
          },
          on: {
            "current-change": _vm.handleCurrentChange3
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.personVisible = false, _vm.searchText = ''
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.orderLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.orderPersonSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("确定")])], 1)], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e03159c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/orderList/OrderAdd.vue
// module id = 1750
// module chunks = 9